// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vHRI","colBig":"styles_colBig__2viRu","colSmall":"styles_colSmall__2fSm5"};